<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'gestoesDeAulas.planosInfantil' })"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Plano Semanal Infantil
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-btn depressed color="primary" @click="() => [visualizarPdf(plano.id)]">
          Visualizar Pdf
          <v-icon small right> mdi-note </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="12" lg="12">
        <v-card>
          <v-card-text>
            <label for="">Professor</label>
            <v-input>
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.professor
                    ? plano.gestao_de_aula.professor.nome
                    : "- - -"
                  : "- - - "
              }}
            </v-input>

            <label for="">Turma</label>
            <v-input>
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.turma
                    ? plano.gestao_de_aula.turma.descricao
                    : "- - -"
                  : "- - - "
              }}
            </v-input>

            <label for="">Disciplina</label>
            <v-input>
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.disciplina
                    ? plano.gestao_de_aula.disciplina.descricao
                    : "- - - "
                  : "- - - "
              }}
            </v-input>

            <label for="">Mês de Referência</label>
            <v-input>
              <v-chip>
                {{ plano.mes?.descricao ?? "- - - " }}
              </v-chip>
            </v-input>

            <label for="">Semana de Referência</label>
            <v-input>
              <v-chip>
                {{ plano.semana?.descricao ?? "- - - " }}
              </v-chip>
            </v-input>

            <label for="">Data lançamento</label>
            <v-input>
              <v-chip>
                {{
                  plano.created_at
                    ? plano.created_at.substr(0, 10).split("-").reverse().join("/")
                    : "- - - "
                }}
              </v-chip>
            </v-input>

            <label for="">Ultima atualização</label>
            <v-input>
              <v-chip>
                {{
                  plano.updated_at
                    ? plano.updated_at.substr(0, 10).split("-").reverse().join("/")
                    : "- - - "
                }}
              </v-chip>
            </v-input>
            <v-combobox v-model="seriesSelecionadas" chips label="Series" multiple readonly />
          </v-card-text>
        </v-card>

        <v-card class="mt-5">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <label for="">Status</label>
                <e-situacao-plano-infantil :plano="plano" v-on:update="listarPlano" />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">OBJETIVOS DE APRENDIZAGEM E DESENVOLVIMENTO</label>
                <div
                  class="pa-2"
                  v-html="formatarTexto(plano.objeto_aprendizagem || '- - -')"
                ></div>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">O QUE VAMOS APRENDER</label>
                <div
                  class="pa-2"
                  v-html="formatarTexto(plano.oque_vamos_aprender || '- - -')"
                ></div>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">METODOLOGIA DAS EXPERIÊNCIAS DE APRENDIZAGEM</label>
                <div
                  class="pa-2"
                  v-html="
                    formatarTexto(plano.medotologia_das_experiencias_de_aprendizagem || '- - -')
                  "
                ></div>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">AVALIAÇÃO DE DESEMPENHO</label>
                <div
                  class="pa-2"
                  v-html="formatarTexto(plano.avaliacao_de_desempenho || '- - -')"
                ></div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ModalCarteira :dialog="dialogPdf" :pdf="pdf" @update="fecharModal" />
  </main-template>
</template>

<script>
import ModalCarteira from "@/components/Matriculas/EModalCarteira.vue";

export default {
  components: {
    ModalCarteira,
  },
  data() {
    return {
      dialogPdf: false,
      pdf: null,
      showSnackbar: false,
      plano: {},
      plano_id: null,
      seriesSelecionadas: [],
      experienciasSelecionadas: [],
      objetivosSelecionados: [],
      recursosSelecionados: [],
      duvidasSelecionadas: [],
    };
  },
  async mounted() {
    this.getId();
    this.listarPlano(this.pageNumber);
  },
  methods: {
    formatarTexto(texto) {
      return texto.replace(/\n/g, "<br>");
    },

    async getId() {
      const { id } = this.$route.params;
      this.plano_id = id;
    },
    async listarPlano() {
      this.$loaderService.open("Carregando Plano");
      try {
        const { data } = await this.$services.planosService.showInfantilSemanal(this.plano_id);

        this.plano = { ...data.planoBimestralInfantil };

        this.seriesSelecionadas = this.plano.gestao_de_aula?.turma.series.map((s) => s.descricao);
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async carregarDadosAoAtualizarStatus() {
      try {
        this.listarPlano();
      } catch (error) {
        this.$handleError(error);
      }
    },

    async visualizarPdf(planoId) {
      try {
        this.$loaderService.open("Carregando dados...");
        this.pdf = await this.$services.planosService.pdfInfantilSemanal(planoId);
        this.dialogPdf = true;
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
        this.$loaderService.close();
      }
    },
    fecharModal() {
      this.dialogPdf = false;
    },
  },
};
</script>

<style></style>
